export default __webpack_public_path__ + "80ae0f14e4fa996b0882139bb815a214.png";